import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { Firestore, getFirestore } from 'firebase/firestore';
import { HttpsCallable, Functions, httpsCallable, getFunctions, HttpsCallableOptions } from 'firebase/functions';
import { getMessaging, getToken, GetTokenOptions, onMessage } from 'firebase/messaging';
import { environment } from 'src/environments/environment';
import { GoogleMap } from '@angular/google-maps';

import { Geolocation } from '@capacitor/geolocation';
import { AuthService } from '@core/auth.service';
import { User } from '@models/user.model';
import { getAuth, signOut } from 'firebase/auth';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  @ViewChild('map') mapView: ElementRef;
  constructor(
    private auth: AuthService
    // private firestore: Firestore,
    // private functions: Functions,
  ) {

  }

  ngOnInit(): void {
    console.log('in app componenet init');
    // signOut(getAuth());
    // httpsCallable(getFunctions(), 'sandbox-sandbox1')().then(res => {
    //   console.log('sandbox res', res);
    // }).catch(err => {
    //   console.log('sandbox err', err);
    // })
    // httpsCallable(getFunctions(), 'email-sendEmail')({
    //   to: 'a.daling@umanity.io',
    //   from: 'hello@umanity.app',
    //   templateId: 'd-e68651b902b14c1fb5ca952b474df8d8',
    //   dynamicTemplateData: {
    //     firstName: 'Alec'
    //   }
    // }).then(res => {
    //   console.log('sandbox res', res);
    // }).catch(err => {
    //   console.log('sandbox err', err);
    // })

    // const email = 'test1@test.com'
    // const u = new User({
    //   firstName: 'test',
    //   lastName: 'test',
    //   email,
    // })
    // this.auth.emailSignup(email, 'testes1', u).then(res => {
    //   console.log('create user response', res);
    // }).catch(err => {
    //   console.log('creat euser error', err);
    // })
  }

  test() {
    console.log('calling testEmail')
    const functions = getFunctions();
    httpsCallable(functions, 'testEmail')({}).then(res => {
      console.log('res', res);
    }).catch(err => {
      console.log('error ', err);
    })
  }

}
